export enum TaskClaims_Enum {
  TASK_CLAIMS = "TASK And CLAIMS",
  APPROVED_CLAIMS = "Approved Claims",
  NEW_CLAIMS = "New Claims",
  PAST_CLAIMS = "Past Claims",
  READY_TO_INVOICE = "Ready to Invoice",
  DRAFTS_ESTIMATION = "Drafts and Estimates",
}

export const TaskClaimsMessages = {
  ITEMS_TABLE_UPDATED: "Items table updated",
  GENERATE_TASK_CLAIMS: "Task and claims are generated from project register",
  ADD_NEW_CLAIMS: "Add New Claims",
  ADD_NEW_INVOICES: "Add New Invoices",
  ACTIVITY_CLICKED: "Activity Clicked",
  INCOMPLETE_PROJECT: "Project  should be 100% to move to completed",

  CLAIMS_TO_COMPLETE: "Claims moved to completed successfully",
  CLAIMS_TO_CLOSED: "Claims moved to closed successfully",
  CLAIMS_OPENED: "Claims opened successfully",

  ESTIMATE_APPROVED: "Estimate Approved Successfully",
  EXPORT_ESTIMATE_INPROGRESS: "Export Estimate in Progress",

  NO_ONGOING_CLAIMS_SHEET: "Claims must be in ongoing status to add variant",
  NO_ONGOING_CLAIMS: "Claims must be in ongoing status to add new claim",
  RESOLVE_EMPTY_VARIANT: "Please resolve the empty variant first",
  VARIANT_ADDED_SUCCESS: "Variant added successfully",
  RESOLVE_READY_TO_INVOICE: "Please resolve ready to invoice first",
  NEW_CLAIMS_ADDED_SUCCESS: "New Claims added successfully",

  QUOTE_VERSION_UPDATE: "Quote Version Updated Successfully.",
};

export const Option_Toast_Message = {
  ADD: "Option Added Successfully",
  DELETE: "Option Deleted Successfully",
  UPDATE: "Option Updated Successfully",
  PO_NUMBER_UPDATE: "PO Number Updated Successfully",
  INVOICE_GENERATED_SUCCESS: "Invoice Generated Successfully",
  INVOICE_DELETED_SUCCESS: "Invoice Deleted Successfully",
};

export enum TaskAndClaimsConstantsLocalKeys {
  SHEET_DATA = "task-and-claims-sheetdata",
}

export const TASK_CLAIMS_CONSTANTS = {
  TITLE: "Task & Claims",
  WARN_ERROR: {
    PREVIOUS_AND_CURRENT_TOTAL_SAME: "previous and current total are the same.",
    CLAIMS_TOTAL_ZERO: "Claims Total cannot be 0 or null.",
    TOTAL_LIMIT_100: "Total Cannot be more than 100.",
    CLAIM_NO_RESTORE: "If you delete this you cannot restore this claim.",
  },
  MESSAGES: {
    TC_TABLE_UPDATED: "Task & Claims table updated.",
    ES_TO_DRAFT: "Estimate moved to drafts successfully.",
    PO_UPDATED: "PO status updated successfully.",
    NEW_BIG_PAST_CLAIM: "New Progress cannot be less than Claimed value ",
    TASK_BD_UPDATED: "Task Breakdown Updated Successfully.",
    OPTION_DELETED: "Option Deleted Successfully.",
  },
};

export enum ClaimSheetTabs {
  APPROVED = "APPROVED",
  DRAFT = "DRAFT",
  ESTIMATE = "ESTIMATE",
  DRIVE = "DRIVE",
}
